import * as actionTypes from './actions';

const initialState = {
  value: 0
};

export default function consultantCount(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CONSULTANT_COUNT_SET: {
      const next = Number(action.payload) || 0;
      return { ...state, value: next };
    }
    default:
      return state;
  }
}
